import { app } from '@/config/index.js'
import { valueOrDefault } from '@/utils/common.js'
import { getCookie } from '@/utils/cookie.js'
import { getBlibliTiketOriginSource } from '@/utils/tenant.js'

const isLocalhost = () => {
  return process.env.NODE_ENV === 'development'
}

const isBlibliAndroidUserAgent = () => {
  const userAgent = valueOrDefault(navigator?.userAgent, '')
  return userAgent.includes('BlibliAndroid')
}

const isTiketAndroidUserAgent = () => {
  const TIKET_USER_AGENT = 'tiketcom/android-version'
  const userAgentNavigator = valueOrDefault(navigator?.userAgent, '')
  const UserAgentCookie = getCookie('Tiket-User-Agent')

  return (
    valueOrDefault(userAgentNavigator.includes(TIKET_USER_AGENT), UserAgentCookie.includes(TIKET_USER_AGENT))
  )
}

const isTiketIosUserAgent = () => {
  const TIKET_USER_AGENT = 'tiketcom/ios-version'
  const userAgentNavigator = valueOrDefault(navigator?.userAgent, '')
  const UserAgentCookie = getCookie('Tiket-User-Agent')

  return (
    valueOrDefault(userAgentNavigator.includes(TIKET_USER_AGENT), UserAgentCookie.includes(TIKET_USER_AGENT))
  )
}

const isAndroid = () => {
  const flags = window._ANDROID_USER_AGENT.split(',')
  const userAgent = navigator.userAgent
  if (valueOrDefault(flags.some(flag => userAgent.indexOf(flag) !== -1), isTiketAndroidUserAgent())) {
    return true
  }
  return false
}

const isIos = () => {
  const flags = window._IOS_USER_AGENT.split(',')
  const userAgent = navigator.userAgent
  if (valueOrDefault(flags.some(flag => userAgent.indexOf(flag) !== -1), isTiketIosUserAgent())) {
    return true
  }
  return false
}

const isApp = () => {
  return valueOrDefault(isAndroid(), isIos())
}

const redirectTo = (pathUrl, router) => {
  if (isLocalhost()) {
    return ''
  } else {
    if (isApp()) {
      window.location.href = window.location.origin + pathUrl
      return
    }
    router.push(pathUrl)
  }
}

const redirectToFullUrl = (url) => {
  if (isLocalhost()) {
    return ''
  } else {
    window.location.href = url
  }
}

const redirectBack = vm => {
  const lastRoute = window.location.href
  setTimeout(() => {
    if (lastRoute === window.location.href) {
      if (isApp()) {
        window.location.href = '/:intent/close'
      } else {
        vm.$router.push('/')
      }
    }
  }, 150)
  vm.$router.back()
}

const openNewTab = (url) => {
  if (isLocalhost()) {
    return ''
  } else {
    if (isApp()) {
      window.location.href = url
    } else {
      window.open(url)
    }
  }
}

const reload = () => {
  if (isLocalhost()) {
    return ''
  } else {
    window.location.reload()
  }
}

const isFromBlibli = () => {
  const referrer = document.referrer
  const origin = window.location.origin
  return referrer.includes(origin)
}

const isFromTiket = () => {
  return getBlibliTiketOriginSource() === 'TIKET'
}

const togglePullToRefresh = (flag) => {
  if (isAndroid()) {
    const pullToRefresh = () => {
      if (typeof window.AppsJsHandler?.setupPullToRefresh == 'function') {
        window.AppsJsHandler.setupPullToRefresh(flag)
      }
    }
    pullToRefresh()
  }
}

const closeWebview = () => {
  if (isLocalhost()) {
    return ''
  } else {
    window.location.href = '/:intent/close'
  }
}

const SECRET_REGEX = /nothirdparty=f28cc33464bcedc1cb08280e7d7fcb8d1aad6fb41e806a62cb4080fe329e8259/

const _hasDisabledThirdPartyScriptCookie = () => {
  return SECRET_REGEX.test(document.cookie)
}

const _hasDisabledThirdpartyScriptQueryParam = () => {
  const url = window.location.href
  return SECRET_REGEX.test(url)
}
const isDisabledThirdPartyScript = () => {
  return _hasDisabledThirdPartyScriptCookie() || _hasDisabledThirdpartyScriptQueryParam()
}

const isPublicPage = () => {
  return window.location.pathname.includes(app.publicPath)
}

const scrollToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
}

export {
  closeWebview,
  isAndroid,
  isApp,
  isBlibliAndroidUserAgent,
  isDisabledThirdPartyScript,
  isFromBlibli,
  isFromTiket,
  isIos,
  isLocalhost,
  isPublicPage,
  isTiketIosUserAgent,
  openNewTab,
  redirectBack,
  redirectTo,
  redirectToFullUrl,
  reload,
  scrollToTop,
  togglePullToRefresh
}
